import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface PWBulkOrderConsignInterface {
  serviceSplitReference?: string
}

export const usePWBulkOrderConsign = () => {
  const mutate = useMutation(
    ({ serviceSplitReference }: PWBulkOrderConsignInterface) => {
      return postAPI(`PWBulkConsignment/ConsignOrders`, {
        serviceSplitReference: serviceSplitReference,
      })
    },
  )

  return mutate
}

export default usePWBulkOrderConsign
